import { render, staticRenderFns } from "./InsightOneLiner.vue?vue&type=template&id=27ec126a&"
import script from "./InsightOneLiner.vue?vue&type=script&lang=ts&"
export * from "./InsightOneLiner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports